import React from 'react';
import {NavLink} from "react-router-dom";
import {concatenate} from "services/string";
import {Icon} from "types/Icon";

// Types ----

type SidebarNavLinkProps = {
  name: string
  icon: Icon
  to: string
}

// Component ----

function SidebarNavLink({name, to, icon: Icon}: SidebarNavLinkProps) {
  return (
    <NavLink
      to={to}
      className={({isActive}) => concatenate(
        isActive ? 'text-gray-900' : 'text-gray-500 hover:text-gray-600',
        'group w-full flex items-center pl-1 pr-1 py-1 text-left text-sm leading-[1.2] font-medium rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand'
      )}>
      {({isActive}) => (
        <div className='flex items-center gap-x-2'>
          <div className={concatenate(
            'flex items-center justify-center w-[34px] h-[31px] rounded-full transition-colors ease-in-out duration-200',
            isActive ? 'bg-brand/20' : 'bg-transparent group-hover:bg-gray-200'
          )}>
            <Icon
              className={concatenate(
                'flex-shrink-0 h-[24px] w-[24px]',
                isActive ? 'text-brand' : 'text-gray-500'
              )}
              aria-hidden="true"
            />
          </div>
          {name}
        </div>
      )}
    </NavLink>
  );
}

// Export ----

export default SidebarNavLink;